import {Component, OnDestroy, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {MenuItem} from 'primeng/api';
import {HAS_GESTION_STOCKS, HAS_VARIATIONS_STOCKS, STOCKS_FEATURES} from 'app/core/constants';
import {Subscription} from 'rxjs';
import {ItemNavigationService} from '../core/services/technique/item-navigation.service';
import {StocksService} from "../core/services/gestion-stock/stocks.service";
import {UtilsService} from "../core/utils/utils.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../core/services/security/auth2.service";

@Component({
    selector: 'yo-gestion-stocks-root',
    templateUrl: './gestion-stocks-root.component.html',
    styleUrls: ['./gestion-stocks-root.component.scss'],
    standalone: false
})
export class GestionStocksRootComponent implements OnInit, OnDestroy {

  subActivePrimaryRoute: Subscription;
  stockFeatures: MenuItem[] = [];
  selectedFeature: MenuItem;
  private subStockAlerteQuantity: Subscription;
  private subUpdateStockAlertQuantity: Subscription;

  constructor(private titleSvc:Title,
              private itemNavSvc: ItemNavigationService,
              private stockSvc: StocksService,
              private utilSvc: UtilsService,
              private router: Router,
              private auth2Svc: Auth2Service) { }

  ngOnInit() {
    this.titleSvc.setTitle('Gestion des stocks');
    this.initMenu(0);
    this.activePrimaryRouteSubscription();
    this.initStockAlerteNumber();
    this.updateStockAlertQuantity();
  }

  ngOnDestroy(): void {
    this.utilSvc.unsubscribe(this.subActivePrimaryRoute);
    this.utilSvc.unsubscribe(this.subStockAlerteQuantity);
    this.utilSvc.unsubscribe(this.subUpdateStockAlertQuantity);
  }

  /**
   * selectionner l'item actif selon la route demandée
   */
  activePrimaryRouteSubscription() {
    this.subActivePrimaryRoute = this.itemNavSvc.primaryRoute$.subscribe((event) => {
      this.selectedFeature = this.itemNavSvc.activePrimaryRoute(event, this.stockFeatures);
    });
  }

  private initStockAlerteNumber() {
    this.subStockAlerteQuantity = this.stockSvc.getStockAlerteQuantity().subscribe(res => {
      this.initMenu(res.one);
    });
  }

  private initMenu(quantity: number) {
    const stockAlerteQuantity = quantity > 0 ? 'Stock minimum : ' + quantity.toString() : 'Stock minimum';
    const iconStockMinimum = quantity > 0 ? 'fa-solid fa-triangle-exclamation' : 'fas fa-cubes';

    const user = this.auth2Svc.utilisateur;
    const hasStocks = this.auth2Svc.hasFeatures(user, [HAS_GESTION_STOCKS]);
    const hasVariations = this.auth2Svc.hasFeatures(user, [HAS_VARIATIONS_STOCKS]);

    this.stockFeatures = [];
    if (hasStocks) {
      this.stockFeatures.push(
        {label:'Matières premières', icon:'fas fa-dolly', routerLink: [`stocks/${STOCKS_FEATURES.MATIERES_PREMIERES}`]},
        {label:'Mouvements', icon:'fas fa-exchange-alt', routerLink: [`${STOCKS_FEATURES.MOUVEMENTS}/grille-mouvements`]},
        {label:'Inventaire', icon:'fas fa-people-carry', routerLink: [`stocks/${STOCKS_FEATURES.INVENTAIRE}`]},
        {label: 'Historique inventaire', icon: 'fas fa-history', routerLink: [STOCKS_FEATURES.HISTORIQUE_INVENTAIRE]},
        {label: 'Validation fin de mois', icon: 'fas fa-check-circle', routerLink: [STOCKS_FEATURES.VALIDATION_INVENTAIRE]}
      );
    }
    if (hasStocks || hasVariations) {
      this.stockFeatures.push(
        {label: 'Variations de stocks', icon: 'fas fa-chart-line', routerLink: [STOCKS_FEATURES.VARIATIONS_STOCKS]}
      );
    }
    if (hasStocks) {
      this.stockFeatures.push(
        {label: stockAlerteQuantity, icon:iconStockMinimum, routerLink: [`stocks/${STOCKS_FEATURES.STOCKS_MINIMUM}`]}
      );
    }

    this.selectedFeature = this.itemNavSvc.activePrimaryRoute({url: this.router.url}, this.stockFeatures);
  }

  private updateStockAlertQuantity() {
    this.subUpdateStockAlertQuantity = this.stockSvc.updateStockAlertQuantity$.subscribe(() => {
      this.initStockAlerteNumber();
    });
  }
}
